import { useState } from "react"

import { useParams } from "@tanstack/react-router"

import { LoginByCodeForm } from "@/components/account/LoginByCodeForm"
import { LoginForm } from "@/components/account/LoginForm"
import { VerifyEmailCodeForm } from "@/components/account/VerifyEmailCodeForm"
import { Button } from "@/components/ui/button"

type LoginPanelsProps = {
  onSuccess: () => void
  onForgotPassword: () => void
  email?: string | null
}

export function LoginPanels({
  onSuccess,
  onForgotPassword,
  email,
}: LoginPanelsProps) {
  const { slug } = useParams({ strict: false })
  const [usePassword, setUsePassword] = useState(false)
  const [pendingEmail, setPendingEmail] = useState<string | null>(null)

  // A password login for an unverified account drops here: verification is
  // code-based now, so finish it on the code screen instead of dead-ending.
  if (pendingEmail) {
    return <VerifyEmailCodeForm email={pendingEmail} slug={slug} />
  }

  if (usePassword) {
    return (
      <>
        <LoginForm
          onSuccess={onSuccess}
          onForgotPassword={onForgotPassword}
          onPendingVerification={setPendingEmail}
          email={email}
        />
        <div className="mt-4 text-center">
          <Button
            variant="link"
            type="button"
            className="p-0 text-neutral-600 hover:text-neutral-800"
            onClick={() => setUsePassword(false)}
          >
            Email me a code instead
          </Button>
        </div>
      </>
    )
  }

  return (
    <LoginByCodeForm
      onSuccess={onSuccess}
      onUsePassword={() => setUsePassword(true)}
      email={email}
    />
  )
}
